import { createContext, useContext } from 'react';

import type { ContributionModel } from './liveDataAdapter';

export const ContributionModelContext = createContext<ContributionModel | null>(null);
export function useContributionModel() {
  const model = useContext(ContributionModelContext);
  if (!model) {
    throw new Error('Contribution Margin needs its native live model.');
  }
  return model;
}
